




import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ExternalVideo',
  props: {
    url: {
      type: String,
      required: true,
    },
    host: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedSrc(): string {
      if (this.host.toUpperCase() === 'YOUTUBE') {
        const id = this.url.substring(this.url.lastIndexOf('/') + 1);
        return `https://www.youtube.com/embed/${id}`;
      }
      return this.url;
    },
  },
});
